import { render } from "./PreschoolPerformancesView.vue?vue&type=template&id=0aaaadc0&ts=true"
import script from "./PreschoolPerformancesView.vue?vue&type=script&lang=ts"
export * from "./PreschoolPerformancesView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__